import { UserStatus } from '@/generated/graphql';

export const DEFAULT_FILTER_USER_GROUPS = [
	UserStatus.Active,
	UserStatus.Awaiting,
	UserStatus.Pending,
];
